import React from 'react';
import PropTypes from 'prop-types';

import {
	Container,
} from './styles';

import BackgroundColor from '../../common/BackgroundColor';
import Layout from './Layout';
import ColumnCount from './ColumnCount';

const Settings = props => {
	return (
		<Container>
			<BackgroundColor
				color={props.options['background-color']}
				updateSettingsHandler={props.updateSettingsHandler}
			/>
			<Layout
				layout={props.options.layout}
				updateSettingsHandler={props.updateSettingsHandler}
			/>
			<ColumnCount
				columnCount={props.options.columnCount || 1}
				updateSettingsHandler={props.updateSettingsHandler}
			/>
		</Container>
	)
}

Settings.propTypes = {
	t: PropTypes.func,
	options: PropTypes.object,
	updateSettingsHandler: PropTypes.func,
}

export default Settings;
